import * as XLSX from "xlsx";

const cols = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export function exportXlsx({ columns, data, sheetName, fileName }) {
  // const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const cellTitles = columns.map((c) => c.header);
  const cellKeys = columns.map((c) => c.key);
  // const header = alphabets.slice(0, cellTitles.length);

  const header = [];

  let count = 0;

  while (count < columns.length) {
    const idx = count % 26;
    const mod = Math.ceil(count / 26);
    const prefix = mod > 0 ? cols[mod - 1] : "";
    header.push(`${prefix}${cols[idx]}`);

    count++;
  }

  const list = [];
  list[0] = {};
  for (let i = 0; i < header.length; i++) {
    const alphabet = header[i];
    list[0][alphabet] = cellTitles[i];

    for (let j = 0; j < data.length; j++) {
      if (!list[j + 1]) {
        list[j + 1] = {};
      }

      list[j + 1][alphabet] = data[j][cellKeys[i]];
    }
  }

  var ws = XLSX.utils.json_to_sheet(list, { header, skipHeader: true });

  var workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, ws, sheetName);

  XLSX.writeFile(workbook, fileName);
}
